import { HistoryIcon, IconButton, isTabletQuery, Modal } from '@higo/ui';
import React, { FC, memo, useState } from 'react';
import {
  PatientExaminationsTable,
  PatientExaminationsTableProps,
} from 'components/PatientExaminationsTable';
import useMedia from 'react-use/lib/useMedia';
import { useDispatchDoctorTrackedType } from 'hooks/useDispatchDoctorTrackedEvent';
import {
  DoctorTrackedType,
  TrackedEventButtonClickAction,
} from '@higo/common/lib/features/TrackedEvent';

export type PatientExaminationsModalProps = PatientExaminationsTableProps;

export const PatientExaminationsModal: FC<PatientExaminationsModalProps> = memo(
  (props) => {
    const deviceQuery = useMedia(`${isTabletQuery}`);
    const sendTrackedEvent = useDispatchDoctorTrackedType();
    const [isVisible, setIsVisible] = useState(false);

    return (
      <>
        <IconButton
          color="secondary"
          size="small"
          icon={<HistoryIcon />}
          id="patient-exams-button"
          onClick={() => {
            setIsVisible(true);
            sendTrackedEvent({
              event: DoctorTrackedType.ButtonClick,
              eventAction:
                TrackedEventButtonClickAction.OpenPatientExaminationHistoryModal,
              patientId: props.patientId,
            });
          }}
        />
        <Modal
          visible={isVisible}
          onClose={() => setIsVisible(false)}
          fullscreen={deviceQuery}
          bigModal={true}
        >
          <PatientExaminationsTable
            {...props}
            onRowNavigate={() => setIsVisible(false)}
          />
        </Modal>
      </>
    );
  },
);
